import { TFunction } from 'i18next';
import _get from 'lodash/get';
import { Task } from 'graphql-common';
import { ChipSizes, ChipTypes } from '@lib/components/Chip/Chip';
import ChipCell from '@lib/components/Table/commonComponents/ChipCell/ChipCell';
import TextCell from '@lib/components/Table/commonComponents/TextCell/TextCell';
import TextLinkCell from '@lib/components/Table/commonComponents/TextLinkCell/TextLinkCell';
import { CellProps } from '@lib/components/Table/types';
import AssetChip from '@lib/components/AssetChip/AssetChip';
import TaskStatusChip from '@lib/components/TaskStatusChip/TaskStatusChip';

export default function getTaskTableColumns({
  t,
  onOpenTaskPage,
}: {
  t: TFunction<'translation', undefined>;
  onOpenTaskPage: (id?: string) => void;
}) {
  return [
    {
      id: 'name',
      Header: t('name'),
      accessor: 'name',
      Cell: (props: CellProps<Task>) => (
        <TextLinkCell
          {...props}
          onClick={() => onOpenTaskPage(props?.item.id)}
        />
      ),
      sortable: true,
      width: 300,
    },
    {
      id: 'status',
      Header: t('status'),
      accessor: 'status',
      Cell: ({ item }: CellProps<Task>) => <TaskStatusChip task={item} />,
      sortable: true,
      width: 200,
    },
    {
      id: 'formName',
      Header: t('form-name'),
      Cell: (props: CellProps<Task>) => {
        const label = _get(props, 'item.formTemplate.name', '');
        if (!label) return '-';
        return <TextCell {...props} value={label} />;
      },
      sortable: true,
      width: 200,
    },
    {
      id: 'formCategoryName',
      Header: t('form-category'),
      Cell: (props: CellProps<Task>) => {
        const label = _get(props, 'item.formTemplate.category.name', '');
        const color = _get(
          props,
          'item.formTemplate.category.color',
          '',
        ) as ChipTypes;
        if (!label) return '-';
        return <ChipCell label={label} type={color} leftIcon="circle" />;
      },
      sortable: true,
      width: 200,
    },
    {
      id: 'siteName',
      Header: t('site'),
      accessor: 'site',
      Cell: (props: CellProps<Task>) => {
        const label = _get(props, 'item.site.name', '');
        if (!label) return '-';
        return <ChipCell label={label} type={ChipTypes.chipGray} />;
      },
      sortable: true,
      width: 200,
    },
    {
      id: 'siteAreaName',
      Header: t('area'),
      accessor: 'siteArea',
      Cell: (props: CellProps<Task>) => {
        const label = _get(props, 'item.siteArea.name', '');
        if (!label) return '-';
        return <ChipCell label={label} type={ChipTypes.chipGray} />;
      },
      sortable: true,
      width: 200,
    },
    {
      id: 'assetName',
      Header: t('asset'),
      Cell: ({ item, ...restProps }: CellProps<Task>) =>
        item.asset ? (
          <AssetChip asset={item.asset} size={ChipSizes.small} />
        ) : (
          <TextCell {...restProps} item={item} value={undefined} />
        ),
      sortable: true,
      width: 200,
    },
  ];
}
